/*
 * @Desc: 
 * @Author: lmy
 * @Date: 2025-07-11 09:48:57
 * @LastEditors: lmy
 * @LastEditTime: 2025-08-20 14:07:21
 * @FilePath: \zhongtai-h5\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'

import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'
// 仅开发环境引入 vConsole
// if (process.env.NODE_ENV !== 'production') {
  // import('vconsole').then(({ default: VConsole }) => {
  //   new VConsole()
  //   console.log('vConsole 已启动')
  // })
// }

Vue.use(Vant)
Vue.prototype.$toast = Toast
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
